var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',[_c('thead',[_c('tr',_vm._l((_vm.headers),function(it){return _c('th',{domProps:{"innerHTML":_vm._s(it)}})}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.records),function(it){return _c('tr',_vm._l((it),function(sit){return _c('td',{domProps:{"innerHTML":_vm._s(sit)}})}),0)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb7915ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table.vue
// module id = null
// module chunks = 